let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("asFaG")).then(() => parcelRequire('d25Nr'));